export default {
  app: {
    title: 'Maxshop · Sistema de Gestão de Contêineres (TMS)',
    brand: 'BrazilTMS',
    brandDesc: 'Plataforma de Gestão Maxshop para Contêineres',
    brtTime: 'Horário de Brasília (GMT-3)'
  },
  login: {
    title: 'Login do Sistema',
    demo: 'TMS',
    username: 'Usuário',
    usernamePlaceholder: 'Digite o usuário',
    password: 'Senha',
    passwordPlaceholder: 'Digite a senha',
    captcha: 'Captcha',
    captchaPlaceholder: 'Digite o captcha',
    captchaLoading: 'Carregando...',
    captchaFailed: 'Falha ao obter captcha, tente novamente',
    captchaImage: 'Captcha',
    submit: 'Entrar',
    loginFailed: 'Falha no login, tente novamente',
    admin: {
      name: 'Administrador Geral / Financeiro',
      desc: 'Importar Faturas · Gerenciar Embarques · Confirmar Armazenagem · Exportar Relatórios',
      badge: 'Acesso Total'
    },
    cargo: {
      name: 'Especialista de Logística (Brasil)',
      desc: 'Confirmar Chegada · Registrar Entrega · Check-in do Armazém · Enviar Fotos',
      badge: 'Acesso Operacional'
    },
    hint: 'Maxshop · Sistema de Gestão de Contêineres',
    langLabel: 'Idioma'
  },
  nav: {
    dashboard: 'Painel',
    shipmentImport: 'Registro de Embarque',
    statusBoard: 'Quadro de Status',
    storageManagement: 'Gestão de Armazenamento',
    userManagement: 'Gestão de Usuários',
    roleManagement: 'Gestão de Perfis',
    transitValue: 'Valor em Trânsito',
    monthlyForecast: 'Previsão Mensal',
    reports: 'Relatórios',
    timelineAnalysis: 'Análise de Lead Time',
    profile: 'Perfil',
    overview: 'Visão Geral',
    importDesc: 'Cadastrar Novo Contêiner',
    manageDesc: 'Visualizar e Processar',
    valueDesc: 'Monitoramento em Tempo Real',
    forecastDesc: 'Previsão de Chegada (ETA)',
    reportDesc: 'Exportar Dados',
    timelineDesc: 'KPIs de Eficiência'
  },
  dashboard: {
    totalOrders: 'Total de Contêineres',
    statusDistribution: 'estatísticas de dados',
    shipping: 'Em Trânsito',
    arrived: 'No Porto',
    pendingDelivery: 'Aguardando Entrega',
    warehouse: 'Em Processamento',
    completed: 'Concluídos',
    recentOrders: 'lista de dados',
    latest5: 'Últimos 5',
    inTransitValue: 'Valor em Trânsito',
    timelineKpi: 'Indicadores de Lead Time',
    transitValuePanel: {
      title: 'Valor Total em Trânsito',
      realtime: 'Em Tempo Real',
      inTransit: 'Valor Total em Trânsito',
      delayed: 'Atrasado em Trânsito',
      inventory: 'Convertido para Estoque',
      completed: 'Ativo Concluído',
      containerUnit: 'contêineres',
      standard: 'Transporte Padrão',
      progress: 'Progresso do Transporte',
      lastUpdate: 'Atualização em Tempo Real',
      trendUp: 'Subindo',
      trendDown: 'Descendo',
      trendNeutral: 'Estável'
    },
    forecastPanel: {
      title: 'Previsão Mensal de Chegada',
      container: 'Contêineres Previstos',
      total: 'Total:',
      items: 'itens',
      clickView: 'Clique para Ver',
      clickRefresh: 'Veja os últimos dados',
      loading: 'Carregando...',
      selectMonth: 'Selecionar Mês'
    },
    actions: {
      detail: 'Detalhes',
      items: 'Itens do Contêiner'
    },
    table: {
      index: 'Índice',
      container: 'Código Padrão do Contêiner',
      containerNo: 'Contêiner',
      billNo: 'Conhecimento (BL)',
      originPort: 'Porto de Origem',
      receivingCompany: 'Importador',
      totalValue: 'Valor (BRL)',
      eta: 'ETA',
      etd: 'ETD',
      ata: 'ATA',
      status: 'Status',
      actions: 'Ações',
      internalCabinetNo: 'Número do gabinete'
    },
    chart: {
      count: 'Quantidade',
      percentage: 'Percentual',
      resetFilter: 'Redefinir Filtro',
      placeholder: 'Posição Reservada (para Gráfico Excepcional)'
    },
    trendChart: {
      title: 'Tendência Mensal de Chegada',
      forecast: 'Previsão de Chegada',
      actual: 'Chegada Real',
      unit: 'contêineres',
      selectYear: 'Selecionar Ano'
    }
  },
  status: {
    shipping: '1. Em Trânsito',
    arrived: '2. No Porto',
    pending_delivery: '3. Aguardando Coleta',
    warehouse: '4. Processamento no Armazém',
    completed: '5. Concluído',
    shippingDesc: 'Cadastro de Embarque (China)',
    arrivedDesc: 'Confirmação de Chegada (ATA)',
    pendingDesc: 'Desembaraço Aduaneiro Concluído',
    warehouseDesc: 'Dupla Verificação (Online/Offline)',
    completedDesc: 'Dados Bloqueados e Arquivados'
  },
  shipment: {
    import: 'Cadastro de Embarque',
    longCode: 'Colar Código Padrão do Contêiner',
    longCodePlaceholder: 'Ex: C-20260512-2-NINGBO-B232113464-YMMU6235123-311-MAXIMO',
    parseCode: 'Decodificar',
    parsedFields: 'Campos Decodificados',
    identifier: 'Identificador (Prefixo)',
    loadingDate: 'Data de Estufagem',
    shift: 'Turno / Lote',
    originPort: 'Porto de Origem',
    billNo: 'Nº do Conhecimento (BL)',
    containerNo: 'Nº do Contêiner',
    internalCabinetNo: 'Nº Interno do Contêiner',
    receivingCompany: 'Importador (Brasil)',
    totalValue: 'Valor Total da Carga (BRL)',
    totalValuePlaceholder: 'Informe o valor total em Reais',
    eta: 'Previsão de Chegada (ETA)',
    etd: 'Previsão de Embarque (ETD)',
    etaPlaceholder: 'Selecione a data prevista de chegada',
    etdPlaceholder: 'Selecione a data prevista de saída',
    submit: 'Cadastrar Contêiner',
    submitSuccess: 'Contêiner cadastrado com sucesso',
    codeFormatError: 'Erro de formato: são necessários 8 segmentos separados por "-"',
    codeSegmentError: 'Erro de formato em um dos segmentos do código',
    allRequired: 'Preencha todos os campos obrigatórios',
    customsClearanceTime: 'Data do Desembaraço Aduaneiro',
    deliveryTime: 'Data/Hora da Coleta (Transportadora)',
    deliveryTimePlaceholder: 'Selecione a data de coleta',
    recordATA: 'Confirmar Chegada (ATA)',
    ataPlaceholder: 'Selecione a data real de chegada',
    skuTitle: 'Itens do Contêiner (Packing List)',
    skuAdd: '+ Adicionar Item',
    skuCode: 'SKU / Modelo',
    skuBoxes: 'Nº de Caixas',
    skuQty: 'Quantidade Total',
    skuPrice: 'Preço Unitário',
    skuRemark: 'Observação',
    skuRemove: 'Remover',
    skuRequired: 'Adicione pelo menos 1 item',
    importXlsx: 'Importar xlsx',
    recent: 'Embarques Recentes',
    records: 'registros',
    table: {
      containerNo: 'Contêiner',
      billNo: 'Conhecimento (BL)',
      originPort: 'Porto de Origem',
      receivingCompany: 'Importador',
      totalValue: 'Valor (BRL)',
      shipDate: 'Data de Embarque',
      eta: 'ETA',
      status: 'Status',
      actions: 'Ações',
      detail: 'Detalhes'
    }
  },
  shipmentImport: {
    importing: 'Importando...',
    parseSuccess: 'Análise concluída',
    remark: 'Observação',
    remarkPlaceholder: 'Digite observação (opcional)',
    confirmTitle: 'Confirmar Cadastro',
    systemCode: 'Código Único do Sistema',
    internalCabinetNo: 'Nº Interno',
    receivingCompany: 'Importador',
    totalValue: 'Valor Total',
    codeAnalysisTitle: 'Protocolo de Decodificação Automática',
    identifier: 'Identificador',
    loadingDate: 'Data de Estufagem',
    shift: 'Nº do Lote',
    originPort: 'Porto de Origem',
    billNo: 'Nº do BL',
    containerNo: 'Nº do Contêiner',
    packingDetail: 'Detalhes de Embalagem',
    sku: 'SKU',
    ctns: 'Nº Caixas',
    pcsPerCtn: 'Itens/Caixa',
    qty: 'Qtd Total',
    unitPrice: 'Preço Unit.',
    totalAmount: 'Valor Total',
    note: 'Obs.',
    confirmHint: 'Confirme os dados acima e clique em "Confirmar" para criar o contêiner. O sistema criará o registro automaticamente.',
    cancel: 'Cancelar',
    creating: 'Criando...',
    confirmCreate: 'Confirmar',
    codeEmptyError: 'O código não pode estar vazio',
    parseCodeFirst: 'Analise o código primeiro',
    enterTotalValue: 'Informe o valor total',
    selectEta: 'Selecione a data ETA',
    selectEtd: 'Selecione a data ETD',
    createFailed: 'Falha ao criar',
    createFailedRetry: 'Falha ao criar, tente novamente',
    invalidFileType: 'Selecione arquivo .xlsx ou .xls',
    importSuccess: 'Importação concluída',
    importFailedCheck: 'Falha na importação, verifique o formato',
    importFailedRetry: 'Falha na importação, tente novamente',
    downloadTemplate: 'Baixar Modelo',
    deleteConfirm: 'Tem certeza que deseja excluir este contêiner? Esta ação não pode ser desfeita!'
  },
  warehouse: {
    title: 'Check-in do Armazém',
    erpStockedIn: 'Registrado no Sistema ERP',
    warehouseChecked: 'Conferência de Descarga Concluída',
    abnormalCheck: 'Estado da Carga *',
    abnormal: 'Com Anomalia (Com Anomalia)',
    normal: 'Sem Anomalia (Sem Anomalia)',
    abnormalType: 'Descrição da Anomalia *',
    abnormalTypePlaceholder: 'Descreva detalhadamente a avaria ou falta...',
    uploadImage: 'Foto do Contêiner *',
    uploadRequired: '⚠️ É obrigatório enviar pelo menos 1 foto do contêiner',
    abnormalRequired: '⚠️ É obrigatório informar se há anomalia',
    erpLocked: 'Operação ERP restrita ao Administrador',
    confirm: 'Finalizar Check-in',
    confirmSuccess: 'Check-in concluído! Contêiner finalizado automaticamente.',
    imageCount: '{count} foto(s) anexada(s)',
    dropHere: 'Arraste a foto aqui ou clique para selecionar'
  },
  transitValue: {
    title: 'Valor Total em Trânsito (Hoje)',
    totalInTransit: 'Valor Total em Trânsito',
    unit: 'BRL',
    containerCount: 'Contêineres em Trânsito',
    containerUnit: 'contêineres',
    description: 'Critério único: caixa [Registrado no ERP] NÃO marcada. Independente da localização física.',
    dynamicDeduction: 'Ao marcar ERP, o valor é deduzido automaticamente do painel em tempo real.',
    notVisibleCargo: 'Este módulo é restrito a Administradores.',
    stockedInValue: 'Valor em Estoque (ERP)',
    completedAssets: 'Ativos Concluídos',
    containerList: 'Lista de Contêineres em Trânsito',
    stockedIn: 'Registrado no ERP',
    notStockedIn: 'Não Registrado',
    erpStockInBtn: 'Entrada ERP',
    erpStockInSuccess: 'Entrada ERP confirmada com sucesso, valor em trânsito deduzido automaticamente',
    table: {
      containerNo: 'Contêiner',
      billNo: 'Conhecimento (BL)',
      goodsValue: 'Valor (BRL)',
      status: 'Status',
      erpStatus: 'ERP',
      actions: 'Ações',
      billNoLabel: 'BL:',
      goodsValueLabel: 'Valor:',
      erpLabel: 'ERP:'
    }
  },
  monthlyForecast: {
    title: 'Previsão Mensal de Chegada',
    selectMonth: 'Selecionar Mês',
    allMonths: 'Todos os Meses',
    predictionList: 'Lista de Previsão',
    etaEmpty: 'ATA Pendente',
    noPrediction: 'Nenhum contêiner previsto',
    rule: 'Regra: ETA dentro do mês selecionado E ATA vazio. Ao registrar ATA, remove automaticamente.',
    table: {
      containerNo: 'Contêiner',
      billNo: 'Conhecimento (BL)',
      eta: 'Previsão de Chegada',
      originPort: 'Porto de Origem',
      goodsValue: 'Valor (BRL)',
      status: 'Status'
    }
  },
  reports: {
    title: 'Exportar Relatórios',
    exportFull: 'Exportar Relatório Completo (Excel)',
    exportCargoList: 'Exportar Packing List (Sem Preços)',
    exportTransit: 'Exportar Em Trânsito (Excel)',
    adminOnly: 'Restrito a Administradores',
    desensitized: 'Lista sem colunas de preço unitário e valor total',
    exportSuccess: 'Relatório exportado com sucesso',
    fullDesc: 'Contém todos os campos: Contêiner, BL, Porto de Origem, Importador, Valor, ETA, ATA, Desembaraço, Entrega, ERP, Anomalias',
    cargoListDesc: 'Sem colunas de preço - Ideal para conferência no local',
    transitDesc: 'Apenas contêineres em trânsito (não concluídos/não registrados no ERP)',
    dataPreview: 'Pré-visualização de Dados',
    records: 'registros',
    customsClearanceTime: 'Desembaraço',
    deliveryTime: 'Entrega',
    noDataExport: 'Nenhum dado para exportar',
    exportSuccessMsg: 'Exportação bem-sucedida',
    exportFailed: 'Falha na exportação',
    networkError: 'Erro de rede'
  },
  statusBoard: {
    export: 'Exportar',
    exportExcel: 'Exportar Excel',
    download: 'Baixar Dados',
    newContainer: 'Cadastrar Contêiner',
    createTitle: 'Cadastrar Contêiner',
    pasteCode: 'Cole o código longo (análise automática e preenchimento reverso)',
    codeExample: 'Exemplo: C - 20260512 - 2 - NINGBO - B232113464 - YMMU6235123 - 311 - MAXIMO',
    codeFormatHint: 'Formato: Identificador - Data de Estufagem - Turno - Porto de Origem - BL - Contêiner - Nº Interno - Importador',
    codeFormatError: 'Formato de código inválido, verifique os separadores ou a integridade dos parâmetros.',
    autoParsedFields: 'Campos analisados automaticamente (somente leitura)',
    manualFields: 'Preencher campos principais',
    skuItems: 'Itens do Contêiner (SKU)',
    noSkuItems: 'Nenhum item cadastrado',
    addSkuItem: 'Adicionar Item',
    saveCreate: 'Salvar e Criar',
    search: {
      containerNo: 'Contêiner',
      internalCabinetNo: 'Nº Interno',
      totalValue: 'Valor',
      receivingCompany: 'Importador',
      placeholderContainerNo: 'Buscar Contêiner',
      placeholderInternalCabinetNo: 'Buscar Nº Interno',
      placeholderTotalValue: 'Buscar Valor',
      placeholderReceivingCompany: 'Buscar Importador'
    },
    sort: {
      eta: 'Ordenar por ETA',
      value: 'Ordenar por Valor',
      date: 'Ordenar por Data de Estufagem'
    },
    table: {
      container: 'Código padrão de contedor',
      containerNo: 'Contêiner',
      internalCabinetNo: 'Nº Interno',
      receivingCompany: 'Importador',
      totalValue: 'Valor',
      eta: 'ETA',
      etd: 'ETD',
      ata: 'ATA',
      shippingRemark: 'Observação de Início de Trânsito',
      shippingRemarkPlaceholder: 'Informe observações (opcional)',
      shippingRemarkImages: 'Imagens de Início de Trânsito',
      deliveryRemark: 'Observação de Entrega',
      shippingImage: 'Imagens de Início de Trânsito',
      arrivalTime: 'Hora de Chegada',
      completedTime: 'Hora de Conclusão',
      actions: 'Ações',
      warehouseChecked: 'inventário',
      abnormal: 'Anomalia',
      hasAbnormal: 'Com Anomalia',
      noAbnormal: 'Sem Anomalia'
    },
    actions: {
      confirmArrival: 'Confirmar Chegada',
      detail: 'Detalhes',
      items: 'Itens do Contêiner',
      rollback: 'Reverter'
    },
    status: {
      completed: 'Concluído',
      readOnly: 'Somente Leitura'
    },
    modal: {
      analysisTitle: 'Conteúdo da Análise de Código',
      internalCabinetNo: 'Nº Interno',
      shift: 'Turno/Lote',
      billNo: 'Conhecimento (BL)',
      containerNo: 'Contêiner',
      originPort: 'Porto de Origem',
      etd: 'ETD',
      eta: 'ETA',
      ata: 'ATA',
      confirmArrivalHint: 'Confirmar que este contêiner chegou ao porto. O sistema registará automaticamente a data atual como ATA.',
      customsClearanceLabel: 'Parâmetro de tempo: 【Horário de Conclusão da Alfândega】(obrigatório)',
      customsClearancePlaceholder: 'Selecionar horário de conclusão',
      deliveryLabel: 'Parâmetro de logística: 【Horário de Entrega】(obrigatório)',
      deliveryPlaceholder: 'Selecionar horário de entrega',
      erpStockedIn: 'ERP já estocado',
      warehouseChecked: 'Descarregamento e inventário concluídos',
      adminDisabled: 'Admin não pode selecionar',
      inspectionResult: 'Resultado da Inspeção no Local:',
      noAbnormal: 'Sem Anomalia',
      hasAbnormal: 'Com Anomalia',
      uploadPhotos: '📸 Enviar fotos de descarregamento/caixa vazia (obrigatório)',
      uploadHint: '💡 É necessário selecionar pelo menos 1 foto para salvar',
      uploadOptional: '💡 Upload de fotos é opcional, para registrar a chegada',
      clickPreview: 'Clique para visualizar',
      uploadPlaceholder: '📸 Clique para enviar',
      abnormalRemark: 'Observação detalhada sobre anomalia (obrigatório)',
      abnormalPlaceholder: 'Descreva detalhadamente os danos ou perdas...',
      erpStocked: 'Estoque ERP',
      warehouseCount: 'Inventário no Armazém',
      completedLocked: '🔒 Dados históricos bloqueados. Apenas super administradores podem reverter.',
      cancel: 'Cancelar',
      confirmArrival: 'Confirmar Chegada',
      saveUpdate: 'Salvar e Processar',
      completed: 'Concluído',
      pending: '⏳ Pendente',
      completedSuccess: '✅ Concluído',
      rollback: 'Reverter Chegada',
      rollbackConfirm: 'Tem certeza que deseja reverter o status de chegada e retornar ao status de pendente? Esta operação limpará os dados relacionados como horário de desalfandegamento.',
      rollbackSuccess: 'Reversão bem-sucedida',
      shippingRemark: 'Observação de Embarque',
      modify: 'Modificar',
      shippingRemarkPlaceholder: 'Digite a observação de embarque (opcional)',
      deliveryRemark: 'Observação de Entrega',
      deliveryRemarkPlaceholder: 'Digite a observação de entrega (opcional)',
      remarkTitle: 'Gerenciamento de Observação',
      noRemarkContent: 'Digite o conteúdo da observação ou envie uma imagem',
      uploadSuccess: 'Envio de imagem bem-sucedido',
      title: {
        shipping: 'Painel de Fluxo de Contêiner',
        arrived: 'Painel de Fluxo de Contêiner — Registrar Horário de Conclusão da Alfândega',
        pending_delivery: 'Painel de Fluxo de Contêiner — Registrar Horário de Entrega',
        warehouse: 'Painel de Fluxo de Contêiner — Verificação Dupla no Armazém Exterior',
        completed: 'Painel de Fluxo de Contêiner — Bloqueado e Concluído'
      }
    },
    containerUnit: 'contêineres',
    create: {
      identifier: 'Identificador',
      loadingDate: 'Data de Estufagem',
      loadingDateExample: 'Exemplo: 2026-07-20',
      shift: 'Turno',
      batchNo: 'Turno/Lote',
      batchNoExample: 'Exemplo: 1',
      originPort: 'Porto de Origem',
      departurePort: 'Porto de Origem',
      departurePortExample: 'Exemplo: SHA',
      billNo: 'Conhecimento (BL)',
      blNo: 'Conhecimento de Embarque',
      blNoExample: 'Exemplo: BL20260727001',
      containerNo: 'Contêiner',
      internalCabinetNo: 'Nº Interno',
      receivingCompany: 'Importador',
      totalValue: 'Valor Total do Contêiner',
      enterValue: 'Digite o valor',
      etd: 'ETD (Data Prevista de Saída)',
      eta: 'ETA (Data Prevista de Chegada)',
      etdExample: 'Exemplo: 2026-07-09',
      etaExample: 'Exemplo: 2026-07-09',
      shipDate: 'Data de Envio',
      shipDateExample: 'Exemplo: 2026-07-28'
    },
    sku: {
      delete: 'Excluir',
      sku: 'SKU',
      skuPlaceholder: 'SKU',
      ctns: 'Caixas',
      ctnsPlaceholder: 'Caixas',
      pcsPerCtn: 'Itens/Caixa',
      pcsPerCtnPlaceholder: 'Itens/Caixa',
      qty: 'Quantidade Total',
      unitPrice: 'Preço Unitário',
      unitPricePlaceholder: 'Preço',
      totalAmount: 'Valor Total',
      note: 'Observação',
      notePlaceholder: 'Obs.',
      autoCalc: 'Automático'
    },
    actionButtons: {
      audit: 'Processar',
      verify: 'Verificar'
    }
  },
  containerDetail: {
    title: 'Detalhes do Contêiner',
    basicInfo: 'Informações Básicas do Contêiner',
    items: 'Itens do Contêiner',
    exportItems: 'Exportar Packing List',
    exportFull: 'Exportar Relatório Completo',
    close: 'Fechar',
    noItems: 'Nenhum item no contêiner',
    missingId: 'ID do contêiner faltante',
    loadFailed: 'Falha ao carregar dados, tente novamente',
    containerNo: 'Contêiner',
    internalCabinetNo: 'Nº Interno',
    blNo: 'Conhecimento (BL)',
    departurePort: 'Porto de Origem',
    receivingCompany: 'Importador',
    loadingDate: 'Data de Estufagem',
    status: 'Status',
    totalValue: 'Valor Total',
    customsClearanceTime: 'Desembaraço Aduaneiro',
    deliveryTime: 'Entrega',
    erpChecked: 'Registrado no ERP',
    warehouseChecked: 'Conferência no Armazém',
    remark: 'Observação',
    anomalyRemark: 'Observação de Anomalia',
    abnormalImages: 'Imagens do armazém ultramarino',
    ctns: 'Nº de Caixas',
    pcsPerCtn: 'Itens por Caixa',
    qty: 'Quantidade Total',
    unitPrice: 'Preço Unitário',
    totalAmount: 'Valor Total',
    total: 'Total',
    note: 'Observação',
    checked: 'Sim',
    unchecked: 'Não',
    editTimes: 'Editar Tempos',
    editTimesTitle: 'Editar Informações de Tempo',
    selectEtd: 'Selecionar data ETD',
    selectEta: 'Selecionar data ETA',
    selectAta: 'Selecionar data ATA',
    cancel: 'Cancelar',
    save: 'Salvar',
    updateSuccess: 'Informações de tempo atualizadas',
    updateFailed: 'Falha ao atualizar informações de tempo',
    images: 'Fotos do Local',
    shippingRemark: 'Observação de Embarque',
    deliveryRemark: 'Observação de Entrega'
  },
  userManagement: {
    title: 'Gerenciamento de Usuários',
    subtitle: 'Gerenciar contas de usuário e atribuição de permissões',
    addUser: 'Novo Usuário',
    searchUsername: 'Pesquisar usuário...',
    allStatus: 'Todos os Status',
    normal: 'Ativo',
    disabled: 'Desativado',
    query: 'Pesquisar',
    reset: 'Resetar',
    userId: 'ID do Usuário',
    username: 'Nome de Usuário',
    nickname: 'Apelido',
    email: 'E-mail',
    phone: 'Telefone',
    status: 'Status',
    role: 'Função',
    createTime: 'Data de Criação',
    actions: 'Ações',
    edit: 'Editar',
    assignRole: 'Atribuir Função',
    resetPassword: 'Resetar Senha',
    enable: 'Ativar',
    disable: 'Desativar',
    delete: 'Excluir',
    noData: 'Nenhum usuário encontrado',
    noDataTip: 'Clique em "Novo Usuário" no canto superior direito para criar',
    addUserTitle: 'Novo Usuário',
    editUserTitle: 'Editar Usuário',
    confirmPassword: 'Confirmar Senha',
    cancel: 'Cancelar',
    confirmSubmit: 'Confirmar Envio',
    assignRoleTitle: 'Atribuir Função',
    saveRole: 'Salvar Função',
    resetPasswordTitle: 'Resetar Senha',
    newPassword: 'Nova Senha',
    password: 'Senha',
    confirmReset: 'Confirmar Reset',
    selectRole: 'Selecionar Função',
    enterEmail: 'Digite o e-mail',
    enterPhone: 'Digite o telefone',
    passwordRule: 'Digite a senha',
    usernameRule: 'Digite o nome de usuário',
    nicknameRule: 'Digite o apelido',
    passwordLengthRule: 'A senha deve ter pelo menos 6 caracteres',
    passwordConfirmRule: 'Digite a senha novamente',
    passwordMismatch: 'As senhas não coincidem!',
    emailRule: 'Digite um e-mail válido',
    phoneRule: 'Digite um telefone válido',
    deleteConfirm: 'Tem certeza que deseja excluir o usuário {name}?',
    deleteTitle: 'Confirmação de Exclusão',
    deleteSuccess: 'Usuário excluído com sucesso',
    deleteFailed: 'Falha ao excluir usuário',
    createSuccess: 'Usuário criado com sucesso',
    createFailed: 'Falha ao criar usuário',
    updateSuccess: 'Informações do usuário atualizadas',
    updateFailed: 'Falha ao atualizar usuário',
    roleAssignSuccess: 'Função atribuída com sucesso',
    roleAssignFailed: 'Falha ao atribuir função',
    passwordResetSuccess: 'Senha resetada com sucesso',
    passwordResetFailed: 'Falha ao resetar senha',
    statusChangeSuccess: 'Usuário {action} com sucesso',
    statusChangeFailed: 'Falha ao {action} usuário',
    userLog: 'Log do Usuário',
    userLogTitle: 'Log do Usuário',
    logContainerCode: 'Código do Container',
    logOperationType: 'Tipo de Operação',
    logStatusChange: 'Mudança de Status',
    logOperator: 'Operador',
    logRemark: 'Observação',
    logOperTime: 'Data da Operação',
    noLogData: 'Nenhum log encontrado',
    close: 'Fechar'
  },
  roleManagement: {
    title: 'Gerenciamento de Funções',
    subtitle: 'Gerenciar funções e permissões',
    addRole: 'Nova Função',
    searchRoleName: 'Pesquisar função...',
    allStatus: 'Todos os Status',
    normal: 'Ativo',
    disabled: 'Desativado',
    query: 'Pesquisar',
    reset: 'Resetar',
    roleId: 'ID da Função',
    roleName: 'Nome da Função',
    roleKey: 'Identificador',
    roleSort: 'Ordem',
    dataScope: 'Escopo de Dados',
    status: 'Status',
    createTime: 'Data de Criação',
    actions: 'Ações',
    edit: 'Editar',
    dataPermission: 'Permissão de Dados',
    menuPermission: 'Permissão de Menu',
    assignUser: 'Atribuir Usuário',
    enable: 'Ativar',
    disable: 'Desativar',
    delete: 'Excluir',
    noData: 'Nenhuma função encontrada',
    noDataTip: 'Clique em "Nova Função" no canto superior direito para criar',
    addRoleTitle: 'Nova Função',
    editRoleTitle: 'Editar Função',
    dataScopeTitle: 'Configurar Escopo de Dados',
    menuPermissionTitle: 'Configurar Permissão de Menu',
    saveSettings: 'Salvar Configuração',
    assignUserTitle: 'Atribuir Usuário',
    confirmAssign: 'Confirmar Atribuição',
    dataScopeAll: 'Todos os Dados',
    dataScopeCustom: 'Escopo Personalizado',
    dataScopeDept: 'Dados do Departamento',
    dataScopeDeptAndBelow: 'Dados do Departamento e Subordinados',
    dataScopeSelf: 'Apenas Meus Dados',
    dataScopeRange: 'Escopo de Dados',
    selectDataScope: 'Selecione o escopo de dados',
    permissionSetting: 'Configuração de Permissão',
    enterRoleName: 'Digite o nome da função',
    enterRoleKey: 'Digite o identificador',
    enterSort: 'Digite a ordem',
    enterRemark: 'Digite uma observação',
    availableUsers: 'Usuários Não Alocados',
    selectedUsers: 'Usuários Alocados',
    add: 'Alocar',
    remove: 'Desalocar',
    searchUser: 'Pesquisar usuário',
    deleteConfirm: 'Tem certeza que deseja excluir a função {name}?',
    deleteTitle: 'Confirmação de Exclusão',
    deleteSuccess: 'Função excluída com sucesso',
    deleteFailed: 'Falha ao excluir função',
    createSuccess: 'Função criada com sucesso',
    createFailed: 'Falha ao criar função',
    updateSuccess: 'Informações da função atualizadas',
    updateFailed: 'Falha ao atualizar função',
    dataScopeSuccess: 'Escopo de dados configurado',
    dataScopeFailed: 'Falha ao configurar escopo de dados',
    menuPermSuccess: 'Permissão de menu salva',
    menuPermFailed: 'Falha ao salvar permissão de menu',
    userAssignSuccess: 'Usuário atribuído com sucesso',
    userAssignFailed: 'Falha ao atribuir usuário',
    statusChangeSuccess: 'Função {action} com sucesso',
    statusChangeFailed: 'Falha ao {action} função',
    remark: 'Observação'
  },
  profile: {
    user: 'Usuário',
    unassignedEmail: 'E-mail não definido',
    unassignedPhone: 'Telefone não definido',
    registeredAt: 'Registrado em',
    basicInfo: 'Informações Básicas',
    manageProfile: 'Gerenciar seu perfil',
    username: 'Nome de Usuário',
    nickname: 'Apelido',
    email: 'E-mail',
    phone: 'Telefone',
    personalIntro: 'Sobre Mim',
    saveChanges: 'Salvar Alterações',
    enterNickname: 'Digite o apelido',
    enterEmail: 'Digite o e-mail',
    enterPhone: 'Digite o telefone',
    introPlaceholder: 'Fale um pouco sobre você...',
    changePassword: 'Alterar Senha',
    securityTip: 'Mude sua senha regularmente para segurança',
    oldPassword: 'Senha Antiga',
    newPassword: 'Nova Senha',
    confirmPassword: 'Confirmar Senha',
    enterOldPassword: 'Digite a senha antiga',
    enterNewPassword: 'Digite a nova senha (mínimo 6 caracteres)',
    confirmNewPassword: 'Confirme a nova senha',
    passwordLengthRule: 'A senha deve ter pelo menos 6 caracteres',
    passwordConfirmRule: 'Digite a senha novamente',
    passwordMismatch: 'As senhas não coincidem!',
    securitySettings: 'Configurações de Segurança',
    manageSecurity: 'Gerenciar opções de segurança da conta',
    loginPassword: 'Senha de Login',
    passwordProtected: 'Senha configurada',
    edit: 'Alterar',
    emailVerification: 'Verificação por E-mail',
    emailBound: 'E-mail vinculado',
    phoneVerification: 'Verificação por SMS',
    phoneBound: 'Telefone vinculado',
    notBound: 'Não vinculado',
    completed: 'Concluído',
    bind: 'Vincular',
    avatarUploadSuccess: 'Avatar enviado com sucesso',
    avatarUploadFailed: 'Falha ao enviar avatar',
    updateSuccess: 'Perfil atualizado com sucesso',
    updateFailed: 'Falha ao atualizar perfil',
    passwordChangeSuccess: 'Senha alterada com sucesso',
    passwordChangeFailed: 'Falha ao alterar senha, verifique a senha antiga',
    emailRule: 'Digite um e-mail válido',
    phoneRule: 'Digite um telefone válido',
    changePasswordBtn: 'Alterar Senha',
    admin: 'Super Administrador',
    cargo: 'Especialista de Logística',
    finance: 'Funcionário Financeiro',
    warehouse: 'Gerente de Armazém',
    normalUser: 'Usuário Comum'
  },
  timelineAnalysis: {
    title: 'Análise de Lead Time da Cadeia',
    shippingCycle: 'Ciclo de Transporte Marítimo',
    shippingCycleDesc: 'ATA - Data de Estufagem',
    customsCycle: 'Ciclo de Desembaraço Aduaneiro',
    customsCycleDesc: 'Data do Desembaraço - ATA',
    deliveryDelay: 'Eficiência da Transportadora',
    deliveryDelayDesc: 'Data de Coleta - Data do Desembaraço',
    totalCycle: 'Lead Time Total',
    totalCycleDesc: 'Data de Conclusão - Data de Estufagem',
    days: 'dias',
    containerDetail: 'Detalhamento por Contêiner',
    avgDays: 'Média',
    minDays: 'Mínimo',
    maxDays: 'Máximo'
  },
  storageManagement: {
    pageTitle: 'Gestão de Armazenamento',
    pageSubtitle: 'Confirmar Entrada',
    pendingTitle: '📦 Confirmação Pendente',
    pendingDesc: 'Equipe confirmou chegada, aguardando entrada do administrador',
    noPendingOrders: 'Nenhum pedido pendente',
    allOrdersProcessed: 'Todos os pedidos processados',
    imagesUploaded: '📸 Enviadas',
    imagesNotUploaded: '📷 Não enviadas',
    confirmStorage: '✅ Confirmar Entrada',
    confirmStorageSuccess: '✅ {containerNo} entrada confirmada',
    completedTitle: '📋 Registros de Entrada',
    orderCount: '{count} pedidos',
    noCompletedRecords: 'Nenhum registro de entrada',
    table: {
      containerNo: 'Contêiner',
      originPort: 'Porto de Origem',
      destinationPort: 'Porto de Destino',
      receivingCompany: 'Importador',
      actualArrival: 'Chegada Real',
      deliveryTime: 'Tempo de Entrega',
      containerImages: 'Fotos',
      actions: 'Ações',
      status: 'Status'
    }
  },
  skuTable: {
    noItems: 'Nenhum item adicionado, clique no botão abaixo para adicionar'
  },
  common: {
    search: 'Pesquisar',
    allStatus: 'Todos os Status',
    noData: 'Nenhum dado encontrado',
    total: 'Total:',
    items: 'itens',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    close: 'Fechar',
    save: 'Salvar',
    edit: 'Editar',
    delete: 'Excluir',
    view: 'Visualizar',
    process: 'Processar',
    upload: 'Enviar',
    logout: 'Sair',
    welcome: 'Bem-vindo(a)',
    logoutSuccess: 'Sessão encerrada',
    success: 'Operação realizada com sucesso',
    error: 'Falha na operação',
    warning: 'Atenção',
    readOnly: 'Somente leitura',
    cargoRole: 'Especialista de Logística',
    adminRole: 'Administrador',
    noPermission: 'Sem permissão para acessar esta página',
    locked: 'Dados Bloqueados (Concluído)',
    back: 'Voltar',
    export: 'Exportar',
    refresh: 'Atualizar',
    loading: 'Carregando...',
    searchPlaceholder: 'Digite o número do contêiner',
    deleteSuccess: 'Excluído com sucesso',
    deleteFailed: 'Falha ao excluir',
    tips: 'Aviso'
  },
  import: {
    errorDialog: {
      title: 'Detalhes de Erro',
      errorCount: 'Total de {count} erros',
      confirm: 'Confirmar',
      errorReason: 'Motivo do Erro',
      containerNo: 'Contêiner'
    }
  }
}
